// Remote
export const IS_STAGING = (process.env.REACT_APP_IS_STAG == 'true');
export const BASE_URL = IS_STAGING ? process.env.REACT_APP_BASE_URL_STAG : process.env.REACT_APP_BASE_URL_PROD;
export const S3_BASE_URL = IS_STAGING ? process.env.REACT_APP_S3_BASE_URL_STAG : process.env.REACT_APP_S3_BASE_URL_PROD;
export const LINKEDIN_REDIRECT_URI = IS_STAGING ? process.env.REACT_APP_LINKEDIN_REDIRECT_URI_STAG : process.env.REACT_APP_LINKEDIN_REDIRECT_URI_PROD;
export const LINKEDIN_CLIENT_ID = IS_STAGING ? process.env.REACT_APP_LINKEDIN_CLIENT_ID_STAG : process.env.REACT_APP_LINKEDIN_CLIENT_ID_PROD;


export const FIREBASE_API_KEY= process.env.REACT_APP_FIREBASE_API_KEY
export const FIREBASE_AUTH_DOMAIN= process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
export const FIREBASE_PROJECT_ID= process.env.REACT_APP_FIREBASE_PROJECT_ID
export const FIREBASE_STORAGE_BUCKET= process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
export const FIREBASE_MESSAGING_SENDER_ID= process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
export const FIREBASE_APP_ID= process.env.REACT_APP_FIREBASE_APP_ID
